import React from 'react';
import { Link, useLocation } from 'react-router-dom';

interface NavLinkProps {
  to: string;
  children: React.ReactNode;
  className?: string;
  mobile?: boolean;
}

const NavLink: React.FC<NavLinkProps> = ({ to, children, className = '', mobile = false }) => {
  const location = useLocation();
  const isActive = location.pathname === to;
  
  const baseClasses = mobile 
    ? "block px-3 py-2 text-lg font-bold uppercase cursor-pointer transition-all duration-300"
    : "px-3 py-2 text-lg font-bold uppercase transition-all duration-300 cursor-pointer drop-shadow-lg";
  
  const activeClasses = isActive 
    ? "text-black border-b-2 border-zbm-secondary" // Pink underline for active
    : "text-black hover:text-gray-700 border-b-2 border-zbm-primary"; // Sky blue underline for inactive
  
  return (
    <Link 
      to={to} 
      className={`${baseClasses} ${activeClasses} ${className}`}
      style={{ fontFamily: 'Prompt, sans-serif' }}
    >
      {children}
    </Link>
  );
};

export default NavLink;
